function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 6.6-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0s12 5.4 12 12zM3.1 12c0 4.9 4 8.9 8.9 8.9s8.9-4 8.9-8.9-4-8.9-8.9-8.9-8.9 4-8.9 8.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 7.8v2.3H6.8c-1 0-1.9.8-1.9 1.9 0 1.1.8 1.9 1.9 1.9H11v2.3c0 .7.8 1.1 1.4.7l5.9-4.2c.5-.4.5-1.1 0-1.4l-5.9-4.2c-.6-.4-1.4 0-1.4.7z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;